import * as React from 'react'

export const ArrowIcon = (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 8.46008C7.77984 8.46008 7.57082 8.36337 7.42832 8.19557L3.42832 3.48551C3.16019 3.16979 3.19878 2.69648 3.5145 2.42836C3.83022 2.16023 4.30353 2.19881 4.57165 2.51454L7.99998 6.55145L11.4283 2.51454C11.6964 2.19881 12.1697 2.16023 12.4855 2.42836C12.8012 2.69648 12.8398 3.16979 12.5717 3.48551L8.57165 8.19557C8.42915 8.36337 8.22013 8.46008 7.99998 8.46008Z"
      fill="#5B5F67"
    />
  </svg>
)

export const BulletIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <circle cx="4" cy="4" r="4" fill="#1936D0" />
  </svg>
)

export const ArrowIconWhite = (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 8.46008C7.77984 8.46008 7.57082 8.36337 7.42832 8.19557L3.42832 3.48551C3.16019 3.16979 3.19878 2.69648 3.5145 2.42836C3.83022 2.16023 4.30353 2.19881 4.57165 2.51454L7.99998 6.55145L11.4283 2.51454C11.6964 2.19881 12.1697 2.16023 12.4855 2.42836C12.8012 2.69648 12.8398 3.16979 12.5717 3.48551L8.57165 8.19557C8.42915 8.36337 8.22013 8.46008 7.99998 8.46008Z"
      fill="#FFFFFF"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/assets/svgs.tsx